import { type RegisterUserResponse, type UserProfile } from '@services/User/declarations'
import { RoleKind } from '@libs/fsc/types/user'

export const profileMock: UserProfile = {
  clubs: [
    {
      club: '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d',
      name: 'Club Deportivo Arsenal',
      profiles: {
        asdfg: {
          hash: 'asdfg',
          accessController: false,
          type: 0,
          preEnrollment: false,
        },
      },
      roles: [
        RoleKind.Manager,
        RoleKind.Guardian,
        RoleKind.Member,
        RoleKind.External,
      ],
      locale: 'en-US',
      hash: '58828b64ea4f33aac0bf',
    },
    {
      club: '/api/clubs/f3594450c5b729898f1b0de6792a96215cb8ace5',
      name: 'Lugo Sala',
      hash: 'd4a4e94ab04f1c581f2d',
      profiles: {},
      roles: [
        RoleKind.Manager,
      ],
      locale: 'en-US',
    },
  ],
  username: '722612102',
  email: 'test@test.com',
  admin: false,
}

export const profileWithAdminMock: UserProfile = {
  ...profileMock,
  admin: true,
}

export const postUserRegisterMock: RegisterUserResponse = {
  token: '',
  token_ttl: 0,
}

export const postCreateProfileMock = {
  '@context': '/api/contexts/ProfilePersonResponse',
  '@id': '/api/profiles/manager/test-profile-id',
  '@type': 'ProfilePersonResponse',
  id: 'test-profile-id',
  name: 'Test Manager',
  surname: 'User',
  email: 'test@example.com',
}

export const postCreateProfileErrorUserMock = {
  invalidParamsList: {
    invalidParams: [
      {
        field: 'user',
        errors: ['User error message'],
      },
    ],
  },
}
